import NewCashSales from "../../../../components/@documents/cash_sales/NewCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CashSalesNewPage() {

    return (
        <NewCashSales 
            routeType={routeTypes.admin}
        />
    )
}